@import '../../../global/global.pcss';

select:hover + div,
select:focus-visible + div {
  @apply border-primary-light text-primary-light;
}
